module.exports = __webpack_public_path__ + "img/samsung-galaxy-s6 copy.40837433.png";